import { Transform } from 'class-transformer';
import { toUnixTimestamp } from 'src/app/shared/util/date-util';

// eslint-disable-next-line @typescript-eslint/naming-convention
export function TransformDate(): any {
  const toPlain = Transform((value: any) => {
    if (value != null)
      return toUnixTimestamp(value);
  }, { toPlainOnly: true });
  const toClass = Transform((value: any) => {
    if (value != null)
      return new Date(value);
  }, { toClassOnly: true });

  return (target: any, key: string): any => {
    toPlain(target, key);
    toClass(target, key);
  };
}
